import { forwardRef, useRef } from "react";
import { Form } from "react-bootstrap";
import { reducerActions } from "../../../Reducers/FormReducer";

const TextBase = forwardRef((props, ref) => {
  const inputRef = useRef();

  const {
    field,
    objectkey,   
    error,
    touched,
    dispatchState
  } = props;

  const handleChange = (event) => {
    dispatchState({ 
      type: reducerActions.ON_CHANGE_TEXTBOX, 
      payload: { 
        key:objectkey,
        value: event.target.value 
      } 
    });
  };

  const handleBlur = () => {
    dispatchState({
      type: reducerActions.ON_BLUR_TEXTBOX,
        payload: { 
          key:objectkey       
        } 
    });    
  };

  return (
    <>
      <label htmlFor={field.fieldId}>
        {field.fieldLabel || field.fieldName}
        {field.fieldRequired && <span className="text-danger">*</span>}
        &nbsp;
      </label>
      <span className="input-wrapper">
        <Form.Control
          ref={inputRef}
          type={field.fieldType}
          id={field.fieldId}
          value={field.fieldValue || ""}
          onChange={handleChange}
          onBlur={handleBlur}
          required={field.fieldRequired}
          maxLength={field.maxLength > 0 ? field.maxLength : 999}
          isInvalid={touched && (!!error || !field.isValid)}
        />
       {error && (
        <Form.Control.Feedback type="invalid">
          {error}
        </Form.Control.Feedback>
      )}
      </span>
    </>
  );
});

export default TextBase;
